import React from 'react';

const WhoIAm = () => {
  return (
    <section id="about" className="bg-[#0B0D10] py-20 lg:py-28" aria-labelledby="who-i-am-heading">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Title */}
        <div className="flex items-center gap-4 mb-12">
          <h2 id="who-i-am-heading" className="text-2xl lg:text-3xl font-semibold text-[#F2F4F7]">
            Who I Am
          </h2>
          <div className="flex-1 h-px bg-white/10" aria-hidden="true" />
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Photo with Vignette Effect */}
          <div className="flex justify-center lg:justify-start">
            <div className="relative w-full max-w-[400px] aspect-square">
              {/* Photo with radial gradient vignette mask */}
              <div 
                className="w-full h-full"
                role="img"
                aria-label="Ramon Govea - Senior Creative Producer and Director"
                style={{
                  background: `url('https://customer-assets.emergentagent.com/job_premium-commercials/artifacts/g6qdgj4w_IMG_0250.jpg') center center / cover no-repeat`,
                  maskImage: 'radial-gradient(ellipse 70% 70% at center, black 30%, transparent 70%)',
                  WebkitMaskImage: 'radial-gradient(ellipse 70% 70% at center, black 30%, transparent 70%)',
                }}
              />
            </div>
          </div>

          {/* Right: Bio Text */}
          <div className="space-y-6">
            <p className="text-[#A6AFBD] leading-relaxed text-base lg:text-lg">
              I&apos;m a senior creative producer and director with over 15 years of experience operating at the intersection of Hollywood, media, and brand-driven storytelling. My background spans film, television, branded content, and interactive media—where creative judgment, strategic clarity, and execution speed are non-negotiable.
            </p>
            <p className="text-[#A6AFBD] leading-relaxed text-base lg:text-lg">
              Over the course of my career, I&apos;ve worked with and alongside figures and organizations such as two-time NBA All-Star and entertainment entrepreneur, Baron Davis, legendary Marvel creator, Stan Lee, leading mobile gaming company, Scopely, & blockbuster franchise studio, Warner Bros. That level of exposure shaped how I think about taste, scale, and what it takes to build content and IP that resonates beyond a single campaign.
            </p>
            <p className="text-[#A6AFBD] leading-relaxed text-base lg:text-lg">
              Today, I bring that same level of creative leadership to narrative, commercial and brand work—partnering with founders, agencies, and marketing teams that want their content to feel intentional, elevated, and expensive, without the inefficiency or overhead of traditional production pipelines.
            </p>
            <p className="text-[#A6AFBD] leading-relaxed text-base lg:text-lg">
              Beyond my role as Chief Creative Officer for entertainment development studio, IP3 and founder of Myth Division, I operate as a high-level creative consultant, designing and executing AI-powered workflows end-to-end to deliver agency-grade results with smaller budgets, faster timelines and tighter control.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoIAm;
